import React, { useEffect, useState } from 'react';
import StyledInput from '../form-control/styledInput/styledInput';
import useTranslation from '@hooks/useTranslation';
import RoundedModal from '@components/roundedModal/roundedModal';
import styles from './RenameModal.module.css';

interface Props {
	onSubmit: (name: string) => void;
	onClose: () => void;
	open: boolean;
	currentName: string;
	/** default to false */
	closeOnMaskClick?: boolean;
	/** default true */
	submitOnEnter?: boolean;
	/** default 'Save' */
	okLabel?: string | React.ReactNode;
	/** default 'Cancel' */
	cancelLabel?: string | React.ReactNode;
	/** default 'Rename' */
	title?: string;
	placeholder?: string;
	width?: number;
}

const RenameModal = (props: Props): React.JSX.Element => {
	const { open, onSubmit, onClose, currentName, closeOnMaskClick, submitOnEnter, okLabel, cancelLabel, title, placeholder, width } = props;
	const [newName, setNewName] = useState(props.currentName);
	const t = useTranslation('Interface.Modals');

	const handleOk = () => {
		onSubmit?.(newName);
	};

	const handleCancel = () => {
		onClose?.();
	};

	const reportClosed = () => {
		onClose?.();
	};

	const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
		if (event.key === 'Enter') {
			handleOk();
		}
	};

	useEffect(() => {
		setNewName(currentName);
	}, [currentName]);

	return (
		<RoundedModal
			closeOnMaskClick={closeOnMaskClick || false}
			onOk={handleOk}
			onCancel={handleCancel}
			onAfterClosed={reportClosed}
			title={title || t('Rename.Title', 'Rename')}
			okBtnLabel={okLabel || t('Rename.OkBtn', 'Save')}
			cancelBtnLabel={cancelLabel || t('Rename.CancelBtn', 'Cancel')}
			disableOkButton={!newName.trim().length}
			visible={open}
			wrapClassName={styles.Wrap}
			maskClassName={styles.Mask}
		>
			<StyledInput
				onChange={(e) => setNewName(e.currentTarget.value)}
				value={newName}
				onKeyDown={handleKeyDown}
				className={styles.Input}
				placeholder={placeholder !== undefined
					? placeholder
					: t('Rename.Placeholder', 'Type a new name')
				}
			/>

	</RoundedModal>
	);
};

export default RenameModal;
